"use strict";

var _interopRequireDefault = require("/usr/local/jpom-server/data/build/9fa77822aff1429c97ab324182a25367/source/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _pubilc = require("@/api/system/pubilc");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// secondary package based on el-pagination
var _default = exports.default = {
  name: 'Download',
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      proList: [],
      listLoading: false,
      total: 0,
      // 总条数
      type: '',
      status: '',
      tenantName: '',
      listQuery: {
        page: 1,
        limit: 10
      }
    };
  },
  created: function created() {
    this.loadPro();
  },
  methods: {
    loadPro: function loadPro() {
      var _this = this;
      this.listLoading = true;
      (0, _pubilc.sysDownload_list)(this.listQuery).then(function (res) {
        // 根据创建时间和当前时间做对比 大于五分钟 canClose 为false
        var now = new Date().getTime();
        res.data.list.forEach(function (item) {
          var createTime = new Date(item.createTime).getTime();
          item.canClose = now - createTime <= 5 * 60 * 1000;
        });
        _this.proList = [];
        _this.proList = res.data.list;
        _this.total = parseInt(res.data.total);
        console.log('Loaded items:', _this.proList);
        setTimeout(function () {
          _this.listLoading = false;
        }, 0.5 * 1000);
      });
    },
    download: function download(item) {
      window.open(item.downloadUrl);
    },
    close: function close(item) {
      var _this2 = this;
      console.log('Closing item:', item);
      this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _pubilc.sysDownload_close)({
          did: item.did
        }).then(function (res) {
          _this2.loadPro();
          _this2.$message({
            type: 'success',
            message: '删除成功!'
          });
        });
      }).catch(function () {});
    }
  }
};